{
  "dashboard": {
    "headTitle": "Billing dashboard",
    "title": "Billing dashboard",
    "scopeTitleGlobal": "Dashboard: entire platform",
    "scopeTitleCompany": "Dashboard: {{name}}",
    "scopeGlobal": "Entire platform",
    "scopeSwitcherAria": "Choose dashboard scope",
    "projectSwitcherAria": "Choose project",
    "subtitle": "Spend and token burn across the platform.",
    "companyHeadTitle": "{{name}} · Billing",
    "companySubtitle": "Usage for this company.",
    "projectHeadTitle": "{{name}} · Billing",
    "projectSubtitle": "Usage inside this project.",
    "openJournal": "Open journal",
    "period24h": "24 hours",
    "period7d": "7 days",
    "period30d": "30 days",
    "period90d": "90 days",
    "periodMonth": "This month",
    "periodAll": "All time",
    "periodApply": "Apply",
    "allStatuses": "All statuses",
    "currency": "Revenue currency",
    "searchPlaceholder": "Search",
    "noResults": "No results",
    "kpi": {
      "cost": "Cost",
      "revenue": "Revenue",
      "units": "Units",
      "tokens": "Tokens",
      "chars": "Characters",
      "duration": "Duration",
      "videoDuration": "Video",
      "audioDuration": "Audio",
      "images": "Images",
      "generations": "Generations",
      "failedRate": "failed",
      "unrated": "Unrated",
      "unratedHint": "Succeeded generations in billable media with no revenue attributed — missing tariff or rating error",
      "avgCost": "Avg / gen",
      "avgPerGen": "avg / gen",
      "deltaVsPrev": "vs previous period of the same length",
      "effectiveRate": "revenue per $1 of cost",
      "effectiveRateHint": "Effective monetization for the period: revenue in the dashboard currency per dollar spent on providers",
      "billedDuration": "Billed duration",
      "promptTokens": "in",
      "completionTokens": "out"
    },
    "series": {
      "title": "Usage over time",
      "metricRevenue": "Revenue",
      "metricCost": "Cost",
      "metricTokens": "Tokens",
      "metricCount": "Count",
      "stackMedia": "By media",
      "stackProvider": "By provider",
      "modeArea": "Area",
      "modeBar": "Bar",
      "empty": "No usage in this period"
    },
    "share": {
      "title": "Cost share",
      "titleRevenue": "Revenue structure",
      "titleCost": "Cost structure",
      "tabMedia": "Media",
      "tabProvider": "Provider"
    },
    "shareMedia": "Cost by media",
    "shareProvider": "Cost by provider",
    "donut": {
      "empty": "No data in this period",
      "revenue": "Revenue",
      "cost": "Cost",
      "units": "Units",
      "tokens": "Tokens",
      "count": "Count"
    },
    "units": {
      "tokens": "tok",
      "video": "video",
      "audio": "audio",
      "chars": "chars",
      "images": "img"
    },
    "table": {
      "name": "Name",
      "cost": "Cost",
      "revenue": "Revenue",
      "revenueShare": "% of revenue",
      "units": "Usage",
      "video": "Video",
      "images": "Images",
      "audio": "Audio",
      "voice": "Voice",
      "text": "Text",
      "tokens": "Tokens",
      "count": "Count",
      "failed": "Failed",
      "total": "Total",
      "openJournal": "Open in journal",
      "empty": "No rows",
      "other": "Other"
    },
    "mediaKinds": {
      "video": "Video",
      "image": "Images",
      "audio": "Audio",
      "voice": "Voice",
      "lipsync": "Lipsync",
      "text": "Text",
      "other": "Other",
      "unknown": "Unspecified"
    },
    "breakdowns": {
      "companies": "By company",
      "projects": "By project",
      "users": "By user",
      "provider_models": "By provider / model",
      "job_kinds": "By job kind",
      "media_kinds": "By media",
      "episodes": "By episode / scene"
    }
  },
  "billingExports": {
    "history": "Export history",
    "historyTitle": "Exports",
    "queued": "Export started — progress is in the task queue.",
    "queueFailed": "Could not start the export",
    "loading": "Loading…",
    "empty": "No exports yet.",
    "loadFailed": "Could not load exports.",
    "download": "Download",
    "cancel": "Cancel",
    "cancelConfirm": "Cancel this export?",
    "cancelFailed": "Could not cancel the export",
    "kinds": {
      "company_operations": "Operations",
      "company_usage": "Usage log",
      "platform_usage": "Usage log",
      "promo_codes": "Promo codes",
      "promo_redemptions": "Redemptions",
      "promo_qr": "QR codes",
      "promo_cards": "Business cards"
    }
  },
  "usage": {
    "headTitle": "Generation journal",
    "title": "Generation journal",
    "count": "{{count}} records",
    "searchPlaceholder": "Search",
    "periodAll": "All time",
    "period24h": "24 hours",
    "period7d": "7 days",
    "allStatuses": "All statuses",
    "allMediaKinds": "All media",
    "allCompanies": "All companies",
    "allProjects": "All projects",
    "allProviders": "All providers",
    "allUsers": "All users",
    "allModels": "All models",
    "allJobKinds": "All job kinds",
    "unsettled": "Not settled",
    "unsettledHint": "Successful generations with revenue that were not charged after the billing mode was enabled. Click to clear the filter",
    "currencyHint": "Revenue in the dashboard currency. Click to show all currencies",
    "currencyMismatch": "Currency ≠ account",
    "currencyMismatchHint": "The event currency differs from its account currency, so it is not charged. Click to clear the filter",
    "unrated": "No tariff",
    "unratedHint": "Successful generations with no matching rate: no price was computed and nothing is charged. Click to clear the filter",
    "export": "Export to XLSX",
    "moreFilters": "More filters",
    "exporting": "Exporting…",
    "exportError": "Export failed",
    "columnsToggle": "Columns",
    "columnsDefault": "Default",
    "columnsSelectAll": "Select all",
    "empty": "No journal records match the filter",
    "prevPage": "Previous",
    "nextPage": "Next",
    "pageOf": "Page {{page}} / {{pages}}",
    "range": "{{from}}–{{to}} of {{total}}",
    "perPage": "{{count}} / page",
    "status": {
      "started": "Started",
      "succeeded": "Succeeded",
      "failed": "Failed"
    },
    "columns": {
      "id": "ID",
      "billing_key": "Billing key",
      "started_at": "Started",
      "finished_at": "Finished",
      "status": "Status",
      "tariff_code": "Tariff",
      "company_id": "Company ID",
      "company_name": "Company",
      "project_id": "Project ID",
      "project_name": "Project",
      "user_id": "User ID",
      "user_email": "User",
      "media_kind": "Media",
      "job_kind": "Job",
      "provider": "Provider",
      "ai_model": "Model",
      "model_id": "Model ID",
      "source_type": "Source type",
      "source_id": "Source ID",
      "generation_job_id": "Job ID",
      "generation_request_log_id": "Request log ID",
      "generation_model_route_id": "Model route ID",
      "season_id": "Season ID",
      "season_number": "Season #",
      "episode_id": "Episode ID",
      "episode_number": "Episode #",
      "scene_id": "Scene ID",
      "scene_number": "Scene #",
      "shot_id": "Shot ID",
      "shot_number": "Shot #",
      "canvas_id": "Canvas ID",
      "canvas_generation_id": "Canvas gen ID",
      "character_id": "Character ID",
      "location_id": "Location ID",
      "prop_id": "Prop ID",
      "voice_id": "Voice ID",
      "medium_id": "Medium ID",
      "camera_preset_id": "Camera ID",
      "animatic_segment_id": "Animatic segment ID",
      "animatic_segment_transcription_id": "Transcription ID",
      "aspect_ratio": "Aspect ratio",
      "requested_image_size": "Image size",
      "requested_resolution": "Resolution",
      "requested_width": "Req. width",
      "requested_height": "Req. height",
      "requested_duration_sec": "Requested duration",
      "generate_audio": "Generate audio",
      "seed": "Seed",
      "use_project_styles": "Project styles",
      "reference_image_count": "Ref. images",
      "reference_video_count": "Ref. videos",
      "spoken_text_length": "Spoken length",
      "provider_voice_id": "Provider voice ID",
      "voice_provider_kind": "Voice provider",
      "sts": "STS",
      "billed_duration_sec": "Billed duration",
      "billed_width": "Billed width",
      "billed_height": "Billed height",
      "prompt_tokens": "Prompt tokens",
      "completion_tokens": "Completion tokens",
      "total_tokens": "Tokens",
      "native_tokens_completion": "Native tokens",
      "estimated_cost_microcents": "Cost (est.)",
      "cost_microcents": "Cost (provider)",
      "billed_units": "Billed units",
      "tariff_unit": "Tariff unit",
      "tariff_base_unit_price_microcents": "Base unit price",
      "tariff_discount_percent": "Rate discount",
      "tariff_unit_price_microcents": "Unit price",
      "pre_plan_revenue_microcents": "Pre-plan revenue",
      "plan_code": "Plan",
      "plan_discount_percent": "Plan discount (%)",
      "plan_discount_amount_microcents": "Plan discount",
      "promotion_code": "Promotion",
      "promotion_discount_percent": "Promotion discount (%)",
      "promotion_discount_amount_microcents": "Promotion discount",
      "revenue_microcents": "Revenue",
      "currency": "Currency",
      "settled_amount_microcents": "Settled",
      "settled_at": "Settled at",
      "rated_at": "Rated at",
      "rating_error": "Rating error",
      "billing_tariff_rate_id": "Tariff rate ID",
      "billing_cost_rate_id": "Cost rate ID",
      "error_message": "Error",
      "settings_json": "settings_json",
      "usage_json": "usage_json",
      "created_at": "Created",
      "updated_at": "Updated"
    },
    "yes": "Yes",
    "no": "No",
    "detail": {
      "title": "Journal record",
      "close": "Close",
      "overview": "Overview",
      "billingKey": "Billing key",
      "tariff": "Tariff",
      "modelId": "Model ID",
      "source": "Source",
      "hierarchy": "Hierarchy",
      "entities": "Entities",
      "request": "Request",
      "billed": "Billed",
      "error": "Error",
      "settingsJson": "settings_json",
      "usageJson": "usage_json",
      "finishedAt": "Finished",
      "createdAt": "Created",
      "size": "Size",
      "promptTokens": "Prompt tokens",
      "completionTokens": "Completion tokens",
      "totalTokens": "Total tokens",
      "nativeTokens": "Native completion tokens",
      "refs": "References",
      "seed": "Seed",
      "generateAudio": "Generate audio",
      "sts": "STS",
      "spokenLength": "Spoken text length",
      "voice": "Voice",
      "aspect": "Aspect",
      "resolution": "Resolution",
      "refsValue": "img {{img}} · vid {{vid}}",
      "rating": "Rating",
      "billedUnits": "Billed units",
      "unitPrice": "Unit price",
      "revenue": "Revenue",
      "estimatedCost": "Cost (estimated)",
      "providerCost": "Cost (provider)",
      "ratedAt": "Rated at",
      "ratingError": "Rating error",
      "loading": "Loading details…",
      "loadError": "Failed to load details",
      "cascade": "Financial cascade",
      "basePrice": "Base unit price",
      "rateDiscount": "Rate discount",
      "discountedUnitPrice": "Rate-discounted price",
      "prePlanRevenue": "Pre-plan revenue",
      "plan": "Plan",
      "planDiscountAmount": "Plan discount",
      "promotion": "Promotion",
      "promotionDiscountAmount": "Promotion discount",
      "finalRevenue": "Final revenue",
      "settled": "Settled",
      "settledAt": "Settled at",
      "statementLink": "Account statement"
    },
    "client": {
      "columns": {
        "revenue_microcents": "Cost",
        "pre_plan_revenue_microcents": "Pre-discount cost"
      },
      "detail": {
        "revenue": "Cost",
        "prePlanRevenue": "Pre-discount cost",
        "finalRevenue": "Total"
      }
    }
  },
  "rates": {
    "costRatesTitle": "Cost rates",
    "costRatesSubtitle": "Provider cost price per model — append-only versions",
    "priceListTitle": "Global price list",
    "priceListSubtitle": "Sell-side tariffs for video seconds and images",
    "companyPriceListTitle": "Company tariffs",
    "companyPriceListSubtitle": "Overrides for {{name}} — fallback to GPL when not overridden",
    "addRate": "Add rate",
    "addTariff": "Add tariff",
    "edit": "Edit",
    "override": "Override",
    "cancelPending": "Cancel pending",
    "cancelPendingConfirm": "Cancel the pending version? The previous open version will be restored.",
    "effectiveRange": "{{from}} – {{till}}",
    "openEnded": "open",
    "overriddenTooltip": "GPL: {{price}}",
    "companyScopeTitle": "Tariffs: {{name}}",
    "scopeGlobal": "Global (GPL)",
    "priceLists": {
      "select": "Price list",
      "create": "New price list",
      "createTitle": "New price list",
      "archive": "Archive",
      "archiveConfirm": "Archive price list “{{name}}”? Its tariffs stay in history, but it can no longer be assigned to an account.",
      "accountsCount": "accounts: {{count}}",
      "name": "Name",
      "currency": "Currency",
      "copyFrom": "Copy tariffs from",
      "copyNone": "Empty list",
      "rate": "Rate: {{from}} per 1 {{to}}",
      "copyHint": "Source prices are divided by the rate; the whole version history is copied. Use 1 for the same currency."
    },
    "export": {
      "button": "Download",
      "title": "Download price list",
      "priceList": "Price list",
      "date": "Prices as of",
      "company": "Client",
      "companyNone": "Not specified",
      "companySearch": "Search companies",
      "discount": "Discount, %",
      "kpNumber": "Proposal number",
      "kpPlaceholder": "Optional",
      "signature": "Director signature",
      "stamp": "Stamp",
      "stampUnavailable": "No stamp uploaded in requisites",
      "search": "Search models",
      "selected": "Selected {{count}} of {{total}}",
      "selectAll": "Select all",
      "clearAll": "Clear all",
      "nothingFound": "Nothing found.",
      "emptyList": "This price list has no active rates.",
      "downloadPdf": "Download PDF",
      "downloadXlsx": "Download XLSX",
      "preparing": "Preparing…",
      "failed": "Export failed: {{message}}"
    },
    "scopeOverrides": "overrides: {{count}}",
    "scopeSwitcherAria": "Choose price list",
    "rateKey": "Key",
    "model": "Model",
    "unit": "Unit",
    "price": "Price",
    "perQuantity": "Per quantity",
    "pricePer": "{{price}} / {{qty}} {{unit}}",
    "resolution": "Resolution",
    "resolutionAny": "Any",
    "variant": "Variant",
    "discount": "Discount",
    "discountedPrice": "Price w/ discount",
    "mediaKind": "Media",
    "validFromNotice": "Changes take effect {{date}}, 00:00 GMT+3",
    "firstVersionNotice": "First version takes effect today (GMT+3)",
    "empty": "No rates yet",
    "history": "History",
    "save": "Save",
    "cancel": "Cancel",
    "unitToken": "token",
    "unitSecond": "second",
    "unitChar": "char",
    "unitImage": "image",
    "unitTokenShort": "tok",
    "unitSecondShort": "sec",
    "unitCharShort": "char",
    "unitImageShort": "img",
    "mediaKinds": {
      "video": "video",
      "image": "image",
      "audio": "audio",
      "voice": "voice",
      "lipsync": "lipsync",
      "text": "text"
    },
    "searchPlaceholder": "Search",
    "selectModel": "Select model",
    "variantOptional": "Variant (optional)",
    "variantAudio": "audio",
    "variantVideoInput": "video input",
    "outputPriceShort": "output",
    "outputPrice": "Output price ($, tokens)",
    "pendingBlocksCreate": "This combination already has a pending version — cancel it first",
    "overrideNotice": "A separate company tariff will be created — effective today (GMT+3)",
    "pricePerUnit": "{{price}} / {{unit}}",
    "editBlockedPending": "Cancel the pending version before editing",
    "notSet": "not set",
    "bulkEdit": "Selected: {{count}}",
    "bulkEditTitle": "Edit {{count}} rates",
    "selectAll": "Select all",
    "clearSelection": "Clear selection",
    "validity": "Effective from (GMT+3)",
    "provider": "Provider",
    "allMediaKinds": "All media",
    "allResolutions": "All resolutions",
    "allUnits": "All units",
    "allStatuses": "All statuses",
    "statusActive": "Active",
    "statusPending": "With pending",
    "statusNotSet": "Not set",
    "statusOwn": "Overridden",
    "statusGpl": "Inherited (GPL)",
    "resetFilters": "Reset",
    "columnsToggle": "Columns",
    "columnsDefault": "Default"
  },
  "plans": {
    "headTitle": "Billing plans",
    "title": "Plans",
    "catalog": "Plan catalog",
    "assignmentsTitle": "Assignments and purchases",
    "create": "New plan",
    "newVersion": "New version",
    "archive": "Archive",
    "archiveConfirm": "Archive plan “{{code}}”? New assignments become unavailable; existing ones keep their terms.",
    "assign": "Assign / sell",
    "empty": "No plans yet",
    "assignmentsEmpty": "No assignments yet",
    "history": "History",
    "columns": {
      "code": "Code",
      "name": "Name",
      "kind": "Kind",
      "terms": "Terms",
      "price": "Price",
      "status": "Status",
      "assignments": "Assignments",
      "createdBy": "Created by",
      "actions": "Actions"
    },
    "kind": {
      "discount": "Discount",
      "deposit": "Deposit"
    },
    "status": {
      "active": "Active",
      "archived": "Archived"
    },
    "termsDiscount": "{{percent}}% off · {{period}}",
    "periodMonths": "{{count}} mo.",
    "periodDays": "{{count}} d.",
    "termsDeposit": "{{price}} → {{credit}}",
    "assignmentColumns": {
      "company": "Company",
      "plan": "Plan",
      "period": "Period",
      "autoRenew": "Auto-renew",
      "state": "Status",
      "createdBy": "By",
      "actions": "Actions"
    },
    "state": {
      "pending": "Pending",
      "active": "Active",
      "expired": "Expired",
      "purchased": "Purchased",
      "refunded": "Refunded",
      "cancelled": "cancelled",
      "expiring": "expiring"
    },
    "cancelAssignment": "Cancel",
    "cancelAssignmentConfirm": "Cancel “{{plan}}” for {{company}}? An active plan stays effective until the end of today; a pending one is deleted.",
    "refund": "Refund",
    "dialog": {
      "createTitle": "New plan",
      "newVersionTitle": "New version: {{code}}",
      "newVersionNotice": "The current active version will be archived; sold assignments keep their snapshot terms.",
      "kind": "Plan kind",
      "code": "Code (slug)",
      "name": "Name",
      "description": "Description",
      "discountPercent": "Discount (%)",
      "periodUnit": "Period",
      "periodMonths": "months",
      "periodDays": "days",
      "periodValue": "Duration",
      "priceRubOptional": "Price (₽, reference)",
      "priceRub": "Price (₽)",
      "creditRub": "Credited (₽)",
      "previewDiscount": "{{percent}}% off for {{period}}",
      "previewDeposit": "Client pays {{price}}, {{credit}} is credited (bonus {{bonus}})",
      "save": "Save",
      "cancel": "Cancel"
    },
    "assignDialog": {
      "title": "Assign / sell a plan",
      "company": "Company",
      "selectCompany": "Select company",
      "plan": "Plan",
      "selectPlan": "Select plan",
      "validFrom": "Start date (MSK)",
      "validFromHint": "No earlier than today (MSK)",
      "autoRenew": "Auto-renew",
      "depositNotice": "Package purchase: client pays {{price}}, {{credit}} is credited to the default account",
      "submitAssign": "Assign",
      "submitPurchase": "Purchase"
    },
    "refundDialog": {
      "title": "Deposit refund",
      "amount": "Refund amount (₽)",
      "memo": "Memo",
      "warning": "A compensating entry will debit the account. If the credit is already spent, the balance goes negative.",
      "creditHint": "Credited by this purchase: {{credit}}",
      "submit": "Refund"
    }
  },
  "promotions": {
    "headTitle": "Billing promotions",
    "title": "Promotions",
    "catalog": "Promotions catalog",
    "create": "New promotion",
    "replace": "Change",
    "disable": "Disable",
    "disableConfirm": "Disable “{{name}}” now? New generations will no longer get this discount.",
    "empty": "No promotions yet",
    "columns": {
      "kind": "Preset",
      "name": "Name",
      "discount": "Discount",
      "period": "Period (MSK)",
      "status": "Status",
      "createdBy": "Author",
      "endedBy": "Stopped by",
      "actions": "Actions"
    },
    "kinds": {
      "non_canvas_image": "Images outside canvas"
    },
    "status": {
      "active": "Active",
      "pending": "Scheduled",
      "ended": "Ended"
    },
    "infinite": "No end date",
    "dialog": {
      "createTitle": "New promotion",
      "replaceTitle": "Change promotion",
      "kind": "Preset",
      "name": "Name",
      "discount": "Discount, %",
      "startsAt": "Starts",
      "endsAt": "Ends",
      "startsAtPlaceholder": "Start date",
      "endsAtPlaceholder": "End date",
      "startsAtClear": "Clear start date",
      "endsAtClear": "Clear end date",
      "memo": "Memo",
      "cancel": "Cancel",
      "submitCreate": "Create",
      "submitReplace": "Save",
      "startsNow": "Leave empty to start now (MSK)",
      "endsOpen": "Leave empty for no end date"
    }
  },
  "accounts": {
    "headTitle": "Company accounts",
    "title": "Accounts",
    "empty": "No companies",
    "columns": {
      "company": "Company",
      "enforcement": "Mode",
      "balance": "Balance",
      "held": "Held",
      "available": "Available",
      "accounts": "Accounts",
      "unsettled": "Discrepancies",
      "currencyMismatch": "Currency ≠ account",
      "links": "Links"
    },
    "unsettledHint": "Succeeded generations with revenue that were never charged after the mode was switched on",
    "currencyMismatchHint": "Events whose currency differs from their account currency are not charged. Open in the journal",
    "defaultBadge": "default",
    "archivedBadge": "archived",
    "noAccounts": "no accounts",
    "companyCardLink": "Company card",
    "statementLink": "Statement",
    "enforcementSince": "Mode enabled {{date}}"
  },
  "enforcement": {
    "off": "Off",
    "shadow": "Monitoring",
    "enforced": "Enforced",
    "offHint": "Billing is idle: generations neither hold nor charge funds.",
    "shadowHint": "We count and charge for reconciliation; generations block after the overdraft allowance is reached.",
    "enforcedHint": "Generations hold funds and are blocked when the balance runs out."
  },
  "statement": {
    "headTitle": "Account statement",
    "title": "Statement: {{account}}",
    "account": "Account",
    "balance": "Balance",
    "held": "Held",
    "available": "Available",
    "allKinds": "All kinds",
    "empty": "No entries",
    "columns": {
      "created_at": "Date (MSK)",
      "kind": "Kind",
      "balance_delta": "Δ balance",
      "held_delta": "Δ held",
      "balance_after": "Balance after",
      "held_after": "Held after",
      "created_by": "By",
      "memo": "Memo",
      "source": "Source"
    },
    "kind": {
      "deposit": "Deposit",
      "adjustment": "Adjustment",
      "transfer_in": "Transfer in",
      "transfer_out": "Transfer out",
      "hold": "Hold",
      "hold_release": "Hold release",
      "settle": "Settle",
      "promo": "Promo code",
      "settle_reversal": "Charge reversal"
    },
    "system": "system",
    "openUsageEvent": "Open in journal",
    "toAccounts": "All accounts",
    "actions": {
      "deposit": "Credit",
      "adjust": "Adjust",
      "transfer": "Transfer",
      "setDefault": "Make default",
      "archive": "Archive",
      "create": "New account"
    },
    "confirmSetDefault": "Make “{{name}}” the default account? New holds and settlements will use it.",
    "confirmArchive": "Archive “{{name}}”? Requires zero balance and no holds."
  },
  "accountDialogs": {
    "depositTitle": "Credit the balance",
    "adjustTitle": "Adjustment",
    "transferTitle": "Transfer between accounts",
    "createTitle": "New account",
    "account": "Account",
    "amountRub": "Amount (₽)",
    "signedAmountRub": "Amount (₽, signed)",
    "amountIn": "Amount ({{currency}})",
    "signedAmountIn": "Amount ({{currency}}, signed)",
    "currency": "Currency",
    "priceList": "Price list",
    "priceListBase": "Base {{currency}}",
    "foreignHint": "Foreign-currency account: for project charges only, topped up manually. It can't become the default account.",
    "settingsTitle": "Account settings",
    "overdraft": "Shadow overdraft ({{currency}})",
    "overdraftDefault": "default",
    "overdraftHint": "Empty means default: the company limit for a ruble account, 0 for a foreign one.",
    "save": "Save",
    "adjustHint": "A positive amount increases the balance, a negative one decreases it. Memo is required.",
    "memo": "Memo",
    "memoRequired": "Memo (required)",
    "fromAccount": "From account",
    "toAccount": "To account",
    "name": "Account name",
    "submit": "Post",
    "createSubmit": "Create",
    "cancel": "Cancel"
  },
  "companyCard": {
    "enforcement": "Billing mode",
    "enforcementConfirmEnforced": "Switch to Enforced? Generations will be blocked when the account has no funds.",
    "enforcementNeedsAccount": "Unavailable: create a default account for the company first.",
    "internalNotice": "System company — not billed",
    "plan": "Active plan",
    "noPlan": "No plan assigned",
    "planTill": "till {{date}}",
    "planExpiringBadge": "expiring",
    "planExpiresIn": "expires in {{count}} d.",
    "planExpiredBadge": "expired",
    "autoRenew": "auto-renew",
    "assignPlan": "Assign plan",
    "plansLink": "Manage plans",
    "accountsTitle": "Accounts",
    "defaultAccount": "Default account",
    "noAccounts": "No accounts — create the default one",
    "accountsCount": "accounts: {{count}}",
    "depositPurchases": "deposit purchases: {{count}}",
    "createAccount": "New account",
    "statement": "Accounts & statement",
    "balance": "Balance",
    "held": "Held",
    "available": "Available"
  },
  "client": {
    "headTitle": "Billing",
    "title": "Billing",
    "nav": {
      "dashboard": "Summary",
      "usage": "Journal",
      "accounts": "Accounts",
      "entries": "Operations",
      "limits": "Limits",
      "requisites": "Requisites",
      "payment": "Payment",
      "reports": "Reports"
    },
    "limitsUnavailable": "Spend limits do not apply in this company.",
    "discount": "{{percent}}% discount",
    "autoRenew": "Auto-renew enabled",
    "planDaysLeftBadge_one": "{{count}} day left",
    "planDaysLeftBadge_other": "{{count}} days left",
    "planExpiredBadge": "expired",
    "usageCount": "Generations",
    "spendPeriod": "Spend in period",
    "daysLeftLabel": "Runway",
    "daysLeftValue_one": "~{{count}} day",
    "daysLeftValue_other": "~{{count}} days",
    "daysLeftHint": "Average spend of {{amount}} per day over the last {{days}}. The forecast gets sharper as history builds up.",
    "daysLeftHintEmpty": "No spend yet — the forecast appears after the first charges.",
    "forecastWindowDays_one": "{{count}} day",
    "forecastWindowDays_other": "{{count}} days",
    "exportXlsx": "Export XLSX",
    "charts": {
      "dynamicsTitle": "Spend dynamics",
      "structureTitle": "Spend structure",
      "metricSpend": "Spend",
      "spendShare": "% of spend",
      "heatmapTitle": "Activity over the year",
      "heatmapLess": "less",
      "heatmapMore": "more",
      "heatmapHint": "Click a day or month to set the period, shift + click for a range",
      "heatmapCountValue_one": "{{count}} generation",
      "heatmapCountValue_other": "{{count}} generations",
      "byProjects": "By project",
      "byUsers": "By user"
    },
    "allAccounts": "All accounts",
    "accountsTitle": "Accounts",
    "accountCreate": "New account",
    "accountCreateHint": "A separate budget account: move funds onto it and bind projects to it.",
    "accountTransferHint": "Only available funds (balance minus held) move between your accounts.",
    "accountRename": "Rename",
    "accountRenameTitle": "Rename account",
    "accountRenameSubmit": "Save",
    "accountSetDefault": "Make default",
    "accountArchive": "Archive",
    "accountActions": "Actions",
    "currencyAccounts": {
      "title": "Currency accounts",
      "openSlice": "Show the dashboard for this account",
      "blocked": "Overdraft used up",
      "negative": "Negative",
      "projects_one": "{{formatted}} project",
      "projects_other": "{{formatted}} projects"
    },
    "accountProjects": "Projects",
    "confirmSetDefault": "Make “{{name}}” the default account? Projects without their own budget will be charged to it.",
    "confirmArchive": "Archive “{{name}}”? Requires zero balance, no held funds and no bound projects.",
    "projectAccountsTitle": "Projects and accounts",
    "projectAccountsEmpty": "No projects yet",
    "projectName": "Project",
    "projectDefaultAccount": "Default",
    "projectDefaultAccountNamed": "Default · {{name}}",
    "projectAccountLabel": "Charged to account",
    "projectAccountInstantSave": "Saved immediately, separately from the other project settings.",
    "projectAccountAria": "Account of the “{{project}}” project",
    "projectAccountsTooltip": "Generations are charged to the project's account. If it runs out of funds, the project's generations are blocked — money is not taken from the default account.",
    "defaultBadge": "default",
    "balance": "Balance",
    "held": "Held",
    "available": "Available",
    "availableBreakdown": "of {{balance}} · {{held}} held",
    "shadowModeNote": "Reconciliation mode: generations block after the overdraft allowance of {{limit}} is reached.",
    "entriesTitle": "Recent operations",
    "entriesEmpty": "No operations yet",
    "accountsEmpty": "No accounts yet",
    "entryDate": "Date",
    "entryAccount": "Account",
    "entryKind": "Operation",
    "entryDelta": "Amount",
    "entryAfter": "Balance after",
    "entryMemo": "Memo",
    "lowBalanceTitle": "Insufficient funds",
    "lowBalanceBody": "Balance: {{balance}}. New generations are blocked.",
    "overdraftLimitTitle": "Overdraft allowance used up",
    "overdraftLimitBody": "Available: {{available}}. Overdraft allowance: {{limit}}. New generations are paused.",
    "topUp": "Top up balance",
    "topUpShort": "Top up →",
    "topUpUnavailableHint": "Invoice top-ups are not set up yet: the platform has not filled in its requisites. Contact your manager.",
    "lowBalanceInvoiceIssued": "Invoice No. {{number}} has been generated — awaiting payment.",
    "discountLabel": "Discount",
    "discountValue": "{{percent}}%",
    "noDiscount": "No discount plan",
    "planExpiresTodayBadge": "expires today",
    "discountLabelTill": "Discount till {{date}}",
    "journalButton": "Generation log",
    "promoCodeButton": "I have a promo code",
    "promoCodeTitle": "Promo code",
    "promoCodeDescription": "The promo code amount is credited to the company's default account.",
    "promoCodeField": "Code",
    "promoCodeSubmit": "Apply",
    "promoCodeCancel": "Cancel",
    "promoCodeHint": "Case does not matter. A code can be applied once.",
    "promoCodeApplying": "Checking",
    "promoCodeSuccessApplied": "Promo code {{code}} applied",
    "promoCodeSuccessAccount": "Default account",
    "promoCodeSuccessDone": "Great"
  },
  "supplier": {
    "title": "Supplier details",
    "headTitle": "Supplier details",
    "notConfiguredTitle": "Details are incomplete",
    "notConfiguredBody": "Until the legal name, INN, settlement account, BIC, correspondent account, bank and the offer agreement are set, clients cannot issue invoices.",
    "save": "Save",
    "saving": "Saving…",
    "saveNote": "Changes apply to new invoices: issued ones keep a snapshot of the details and are never rewritten.",
    "org": {
      "title": "Organization",
      "legalName": "Full legal name",
      "legalNameNote": "Including the legal form, exactly as in the state register.",
      "shortName": "Short name",
      "shortNameNote": "Printed in the invoice header and in the payee field.",
      "inn": "INN",
      "lookup": "Look up by TIN",
      "lookupNote": "Fills in the name, KPP, OGRN, address and director from the state registry. Fields you typed by hand are left alone.",
      "lookupUnavailable": "Autofill is not configured — set the DaData key below and save, or fill the fields in manually.",
      "lookupFailed": "Could not fetch the data — fill the fields in manually.",
      "kpp": "KPP",
      "kppNote": "Sole proprietors have no KPP — leave it empty.",
      "ogrn": "OGRN / OGRNIP",
      "ogrnNote": "13 digits for a company, 15 for a sole proprietor.",
      "legalAddress": "Legal address"
    },
    "bank": {
      "title": "Bank details",
      "name": "Beneficiary bank",
      "nameNote": "The payment name of the bank — exactly as in the beneficiary bank field of a payment order.",
      "bic": "BIC",
      "bicNote": "The bank name and correspondent account are filled in from the BIC.",
      "corrAccount": "Correspondent account",
      "settlementAccount": "Settlement account",
      "settlementAccountNote": "20 digits. Spaces and separators are stripped on save."
    },
    "vat": {
      "title": "VAT",
      "mode": "VAT mode",
      "modes": {
        "none": "No VAT",
        "included": "VAT included"
      },
      "rate": "VAT rate",
      "rate22Hint": "Standard rate from 01.01.2026.",
      "rateNote": "The rate goes into the invoice and the payment purpose. Already issued invoices keep theirs.",
      "exemptionReason": "Exemption grounds",
      "exemptionPlaceholder": "VAT exempt under cl. 26 p. 2 art. 149 of the Russian Tax Code",
      "exemptionNote": "Printed on the invoice instead of the tax amount. If empty, the invoice just says “No VAT”."
    },
    "sign": {
      "title": "Signatories and stamp",
      "directorName": "Director name",
      "directorPost": "Director title",
      "directorPostPlaceholder": "Chief Executive Officer",
      "accountantName": "Chief accountant name",
      "accountantNote": "Leave empty and the “Chief accountant” line is not printed on the invoice.",
      "stamp": "Signature and stamp image",
      "stampNote": "Stamps have been optional since 2015 (Federal Law 82-FZ of 06.04.2015), but the counterparty's accounting team usually expects one. A PNG with a transparent background works best.",
      "stampUpload": "Upload file",
      "stampReplace": "Replace file",
      "stampRemove": "Remove",
      "stampRemoveConfirm": "Remove the stamp image? New invoices will be printed without a signature or stamp.",
      "stampEmpty": "No file uploaded",
      "stampPending": "Will be uploaded on save: {{name}}"
    },
    "invoice": {
      "title": "Invoices",
      "numberPrefix": "Number prefix",
      "numberPrefixNote": "Placed before the sequential invoice number. May be left empty.",
      "dueDays": "Invoice validity, days",
      "dueDaysNote": "After this many days the invoice counts as expired. Defaults to 5.",
      "minAmount": "Minimum top-up amount, ₽",
      "minAmountNote": "0 or empty disables the minimum. It does not apply to invoices issued by the platform.",
      "minAcquiringAmount": "Minimum card/SBP payment, ₽",
      "minAcquiringAmountNote": "For solo accounts (YooKassa acquiring). Default 1000 ₽. 0 disables the minimum. Does not apply to legal-entity bank invoices. From Creator Studio a payment below the minimum is allowed for the generation shortage or full cost.",
      "offer": "Public offer",
      "offerNone": "No offer",
      "offerOption": "{{title}} · rev. {{version}}",
      "offerNote": "The revision is pinned on every invoice: changing the offer does not affect the ones already issued.",
      "offerRequired": "Invoice issuing is blocked until an offer agreement is selected.",
      "itemTitleTemplate": "Line item template",
      "itemTitleTemplateNote": "The only row in the invoice table, up to 255 characters. Empty — the template from the placeholder applies.",
      "purposeTemplate": "Payment purpose template",
      "purposeTemplateNote": "Field 24 of the payment order, up to 210 characters — long purposes are shortened automatically. The %{invoice_number} variable is required; the VAT line is appended automatically when missing.",
      "variablesTitle": "Template variables",
      "previewTitle": "Preview with sample data",
      "previewItemTitle": "Line item",
      "previewPurpose": "Payment purpose",
      "contactEmail": "Contact email",
      "contactPhone": "Contact phone",
      "contactNote": "Contacts are printed in the invoice footer."
    },
    "dadata": {
      "title": "Autofill by INN (DaData)",
      "description": "Enter a TIN and the requisites are filled in from the state registry, while a BIC expands into the bank name and correspondent account. The same key powers the client requisites form.",
      "key": "DaData API key",
      "keyPlaceholderSaved": "Key is saved — leave empty to keep it",
      "keyPlaceholderEmpty": "Paste the DaData key",
      "keyNote": "The key is never shown after saving. An empty field does NOT erase the stored key.",
      "keyNoteEnv": "If no key is set here, the DADATA_API_KEY environment variable is used.",
      "statusOn": "Autofill enabled",
      "statusOff": "Autofill disabled"
    }
  },
  "platformInvoices": {
    "headTitle": "Invoices",
    "title": "Invoices",
    "empty": "No invoices",
    "issueInvoice": "Issue invoice for a company",
    "supplierNotConfigured": "Supplier requisites are not filled in — invoices cannot be issued. Fill in the supplier requisites section.",
    "supplierSetupLink": "Fill in supplier requisites",
    "pendingOrders": "Unreviewed payment orders: {{count}}",
    "pendingOrdersHint": "Payment orders uploaded by clients that nobody has reviewed yet",
    "pendingOrderRow": "A payment order is attached — pending review",
    "expired": "Overdue",
    "downloadInvoice": "Download invoice",
    "filters": {
      "allStatuses": "All statuses",
      "allCompanies": "All companies",
      "companySearch": "Search company",
      "companyEmpty": "No company found",
      "searchPlaceholder": "Invoice number",
      "overpaid": "Overpaid",
      "expired": "Overdue"
    },
    "columns": {
      "number": "Number",
      "order": "Order",
      "company": "Company",
      "issued_on": "Issued",
      "due_on": "Due",
      "amount": "Amount",
      "paid": "Paid",
      "outstanding": "Outstanding",
      "status": "Status",
      "payer_inn": "Payer INN",
      "actions": "Actions"
    },
    "status": {
      "issued": "Awaiting payment",
      "partially_paid": "Partially paid",
      "paid": "Paid",
      "overpaid": "Paid",
      "cancelled": "Cancelled"
    },
    "overpaidNote": "overpaid by {{amount}}",
    "paymentOrderStatus": {
      "pending": "Pending review",
      "accepted": "Accepted",
      "rejected": "Rejected"
    },
    "actions": {
      "accept": "Credit payment",
      "acceptShort": "Credit",
      "cancel": "Cancel invoice",
      "reissue": "Reissue",
      "rejectOrder": "Reject order"
    },
    "panel": {
      "title": "Invoice No. {{number}}",
      "overview": "Overview",
      "billingAccount": "Balance account",
      "purpose": "Payment purpose",
      "vat": "VAT",
      "vatIncluded": "VAT {{rate}}% included — {{amount}}",
      "vatNone": "No VAT",
      "contract": "Contract",
      "createdBy": "Issued by",
      "cancelReason": "Cancellation reason",
      "acceptUnavailable": "A payment can only be credited to an invoice that is awaiting payment or partially paid",
      "cancelUnavailable": "Only an invoice without credited payments can be cancelled: money on the balance is returned with an adjustment",
      "payer": {
        "title": "Payer",
        "name": "Legal name",
        "inn": "INN",
        "account": "Settlement account"
      },
      "payments": {
        "title": "Credited payments",
        "empty": "No payments"
      },
      "orders": {
        "title": "Payment orders",
        "empty": "No payment orders",
        "number": "Order No. {{number}}",
        "withoutNumber": "Order without number",
        "noFile": "no file",
        "rejectionReason": "Rejection reason: {{reason}}",
        "accountMatch": "matches",
        "accountUnknown": "not found among company accounts"
      },
      "companyAccounts": {
        "title": "Company bank accounts",
        "empty": "The company has no active bank accounts.",
        "defaultBadge": "primary",
        "expectedBadge": "expected"
      }
    },
    "reissueConfirm": "Reissue invoice No. {{number}}? The old invoice will be cancelled; the new one keeps the order number."
  },
  "invoiceDialogs": {
    "cancel": "Cancel",
    "accept": {
      "title": "Credit payment",
      "subtitle": "Invoice No. {{number}} · {{company}}",
      "submit": "Credit",
      "warning": "The money is credited to the company balance immediately and irreversibly. Mistakes are fixed with a balance adjustment, not by cancelling the payment.",
      "paymentOrder": "Payment order",
      "noPaymentOrder": "Without payment order",
      "orderWithoutNumber": "Order without number",
      "amountRub": "Received amount, ₽",
      "receivedOn": "Received on",
      "outstandingHint": "Outstanding on the invoice: {{amount}}. Partial payments and overpayments are allowed.",
      "overpayWarning": "The amount exceeds the outstanding balance — the invoice is marked paid with an overpayment and the full amount is credited.",
      "memo": "Memo"
    },
    "reject": {
      "title": "Reject payment order",
      "subtitle": "Order {{number}}",
      "submit": "Reject",
      "hint": "The invoice stays open: the client can upload another file.",
      "reason": "Rejection reason"
    },
    "cancelInvoice": {
      "title": "Cancel invoice",
      "subtitle": "Invoice No. {{number}}",
      "submit": "Cancel invoice",
      "warning": "An invoice is immutable: a cancelled number is never reused, a new invoice is issued instead.",
      "reason": "Cancellation reason"
    },
    "issue": {
      "title": "Issue invoice for a company",
      "submit": "Issue",
      "hint": "The invoice uses the company payer requisites and is credited to the selected billing account (the default one unless changed). Without requisites the server returns an error.",
      "company": "Company",
      "companySearch": "Search company",
      "companyEmpty": "No company found",
      "companyPlaceholder": "Select a company",
      "amountRub": "Invoice amount, ₽",
      "minAmountHint": "Client-side minimum is {{amount}}; it does not apply to platform-issued invoices.",
      "billingAccount": "Credit to account",
      "contractReference": "Contract No. (optional)"
    }
  },
  "pendingPayment": {
    "title": "Payment for invoice No. {{number}} awaits acceptance",
    "outstanding": "{{amount}} due",
    "order": "payment order No. {{number}}",
    "orderPaidOn": "of {{date}}",
    "orderAmount": "for {{amount}}",
    "accept": "Accept"
  },
  "invoices": {
    "expired": "Overdue",
    "download": "Download invoice",
    "sendEmail": "Email to accountant",
    "sendEmailTitle": "Email the invoice to an accountant",
    "sendEmailFor": "Invoice No. {{number}} will be sent as an email with a PDF attachment.",
    "sendEmailHint": "We will send an email with the invoice PDF to the address below.",
    "sendEmailAddress": "Accountant email",
    "sendEmailSubmit": "Send",
    "paymentOrderNumbered": "Payment order No. {{number}}",
    "paymentOrderUnnumbered": "Payment order without number",
    "statusLabel": {
      "issued": "Awaiting payment",
      "partially_paid": "Partially paid",
      "paid": "Paid",
      "overpaid": "Paid",
      "cancelled": "Cancelled"
    },
    "overpaidNote": "overpaid by {{amount}}",
    "paymentOrderStatus": {
      "pending": "Pending review",
      "accepted": "Accepted",
      "rejected": "Rejected"
    },
    "print": {
      "chromeTitle": "Invoice No. {{number}}",
      "headTitle": "Invoice No. {{number}}",
      "print": "Print",
      "paymentOrdersTitle": "Payment orders",
      "paymentOrderUploaded": "Uploaded {{at}}",
      "paymentOrderRejected": "Rejection reason: {{reason}}"
    },
    "title": "Invoices",
    "issue": "Top up balance",
    "issueInvoice": "Generate invoice",
    "supplierNotConfigured": "Invoice top-ups are not set up yet — contact your manager:",
    "needRequisites": "Fill in your billing details first — they go into the invoice.",
    "empty": "No invoices yet. Generate a top-up invoice, pay it from your bank account — once the money arrives we credit it to your balance.",
    "number": "Invoice no.",
    "issuedOn": "Generated",
    "dueOn": "Pay by",
    "amount": "Amount",
    "paidAmount": "Paid",
    "outstanding": "Outstanding",
    "status": "Status",
    "actions": "Actions",
    "open": "Open invoice",
    "uploadPaymentOrder": "Attach payment order",
    "attachPaymentOrder": "Attach payment order",
    "cancel": "Cancel invoice",
    "cancelConfirm": "Cancel invoice no. {{number}}? It will no longer be payable — generate a new one instead.",
    "reissue": "Reissue invoice",
    "reissueConfirm": "Reissue invoice No. {{number}}? The old invoice will be cancelled; the new one keeps the order number.",
    "paymentOrdersOf": "Payment orders for invoice no. {{number}}:",
    "issueTitle": "Top up balance",
    "issueHint": "The number and the PDF are created immediately. An invoice cannot be edited: if the amount is wrong, cancel it and generate a new one.",
    "issueSubmit": "Generate invoice",
    "minAmountHint": "Minimum top-up: {{amount}}",
    "topUpSummaryTotal": "Total due {{amount}}",
    "topUpSummaryVat": "incl. VAT {{rate}}% {{amount}}",
    "topUpSummaryNoVat": "No VAT",
    "topUpSummaryDue": "pay by {{date}}",
    "awaitingBannerTitle": "Invoice No. {{number}} is awaiting payment",
    "awaitingBannerAmount": "Amount {{amount}}",
    "awaitingBannerOutstanding": "outstanding {{amount}}",
    "awaitingBannerDue": "pay by {{date}}",
    "awaitingBannerPending": "Payment order under review",
    "issuedBannerTitle": "Invoice No. {{number}} for {{amount}} ₽ has been generated",
    "issuedBannerStep1": "Download the invoice or copy the requisites for your payment order.",
    "issuedBannerStep2": "Pay from your company bank account by {{date}}.",
    "issuedBannerStep3": "Once the money arrives we credit it to your balance and let you know.",
    "copyRequisites": "Copy requisites",
    "copyRequisitesDone": "Copied",
    "paymentOrderTitle": "Attach payment order",
    "paymentOrderFor": "Invoice no. {{number}}",
    "paymentOrderHint": "Optional, but it speeds up payment verification.",
    "paymentOrderPick": "Choose a file",
    "paymentOrderNoFile": "No file chosen — PDF, scan or a bank export",
    "paymentOrderNumber": "Order number",
    "paymentOrderPaidOn": "Payment date",
    "paymentOrderPayerAccount": "Payer account",
    "paymentOrderSubmit": "Attach",
    "payerBankAccount": "Bank account you will pay from",
    "billingAccount": "Credit to account",
    "billingAccountTooltip": "Credits the “{{name}}” balance account"
  },
  "requisites": {
    "title": "Billing details",
    "add": "Add details",
    "emptyTitle": "Add your billing details to top up the balance",
    "emptyHint": "We need your legal name, tax ID and bank account — the same ones your payment order carries.",
    "stateWarning": "not listed as active in the state register",
    "edit": "Edit",
    "innShort": "INN / KPP",
    "ogrn": "OGRN",
    "legalAddress": "Legal address",
    "bankName": "Bank",
    "settlementAccount": "Settlement account",
    "createTitle": "Payer details",
    "topUpStepRequisites": "Details",
    "topUpStepAmount": "Amount",
    "editTitle": "Edit payer details",
    "dialogHint": "These go into the invoice as they are — check them against your registration documents.",
    "save": "Save",
    "sectionParty": "Organization",
    "sectionBank": "Bank details",
    "sectionContacts": "Signatory and contacts",
    "bankHint": "Required — we match your incoming payment by the settlement account.",
    "payerKind": "Payer type",
    "inn": "Tax ID (INN)",
    "kpp": "KPP",
    "legalName": "Full legal name",
    "shortName": "Short name",
    "bankBic": "BIC",
    "bankCorrAccount": "Correspondent account",
    "lookupParty": "Look up by INN",
    "lookupUnavailable": "Autofill is not configured — fill the fields in manually.",
    "lookupFailed": "Could not fetch the data — fill the fields in manually.",
    "directorName": "Director",
    "directorPost": "Position",
    "contactEmail": "Email",
    "contactPhone": "Phone",
    "kind": {
      "organization": "Organization",
      "entrepreneur": "Sole proprietor",
      "individual": "Individual"
    }
  },
  "bankAccounts": {
    "title": "Bank accounts",
    "add": "Add account",
    "defaultBadge": "primary",
    "bic": "BIC",
    "makeDefault": "Make primary",
    "edit": "Edit",
    "archive": "Archive",
    "archiveBlocked": "This is the only active account — a top-up invoice cannot be generated without it",
    "archiveConfirm": "Archive the account “{{name}}”? Invoices already generated stay untouched.",
    "createTitle": "Bank account",
    "editTitle": "Edit bank account",
    "dialogHint": "We match your incoming payment by the settlement account — add the one you will pay from.",
    "save": "Save",
    "label": "Label",
    "labelPlaceholder": "E.g. “Sber” or “Tochka”",
    "makeDefaultCheckbox": "Make primary"
  },
  "onlinePayments": {
    "title": "YooKassa online payments",
    "subtitle": "Card and SBP top-ups. No manual accept — funds are already on the balance.",
    "allStatuses": "All statuses",
    "filterStatus": "Status",
    "empty": "No online payments yet",
    "total": "Total: {{count}}",
    "colWhen": "When",
    "colCompany": "Company",
    "colAmount": "Amount",
    "colStatus": "Status",
    "colIntent": "Intent",
    "colYookassa": "YooKassa ID"
  },
  "promoCodes": {
    "headTitle": "Promo codes",
    "title": "Promo codes",
    "tabs": {
      "codes": "Promo codes",
      "redemptions": "Redemptions"
    },
    "create": "New promo code",
    "empty": "No promo codes found",
    "pause": "Pause",
    "resume": "Resume",
    "pauseConfirm": "Pause promo code “{{code}}”? It cannot be redeemed until resumed; credited funds stay.",
    "pauseSelectedConfirm": "Pause the selected promo codes ({{count}})? They cannot be redeemed until resumed.",
    "noExpiry": "no expiry",
    "limitClosed": "{{count}} companies",
    "kind": {
      "open": "Open",
      "closed": "Closed"
    },
    "state": {
      "active": "Active",
      "exhausted": "Exhausted",
      "expired": "Expired",
      "paused": "Paused"
    },
    "allKinds": "All types",
    "allStates": "All statuses",
    "allCompanies": "All companies",
    "allCreators": "All creators",
    "allCodes": "All codes",
    "allUsers": "All users",
    "columns": {
      "id": "ID",
      "code": "Code",
      "kind": "Type",
      "amount": "Amount",
      "redeemed": "Used",
      "limit": "Limit",
      "expires": "Valid until",
      "state": "Status",
      "comment": "Comment",
      "created_by": "Created by",
      "created_at": "Created",
      "landing_url": "Link"
    },
    "redemptionColumns": {
      "id": "ID",
      "created_at": "Date (MSK)",
      "company": "Company",
      "code": "Code",
      "kind": "Code type",
      "amount": "Amount",
      "redeemed_by": "Redeemed by"
    },
    "redemptionsEmpty": "No redemptions found",
    "statement": "Statement",
    "actions": {
      "copyLink": "Copy link",
      "copyImage": "Copy QR image",
      "downloadSvg": "Download SVG",
      "downloadPng": "Download PNG",
      "card": "Card",
      "downloadCard": "Download print-ready business card (PDF)",
      "linkCopied": "Link copied",
      "linksCopied": "Links copied: {{count}}",
      "imageCopied": "Image copied",
      "copyFailed": "Copy failed",
      "downloadFailed": "Download failed",
      "copyCode": "Copy code",
      "codeCopied": "Code copied",
      "copy": "Copy"
    },
    "bulk": {
      "selected": "Selected: {{count}}",
      "selectAll": "Select all",
      "clearSelection": "Clear selection",
      "copyLinks": "Copy links",
      "downloadQr": "Download QR",
      "downloadingQr": "Preparing archive…",
      "downloadCards": "Business cards",
      "downloadingCards": "Preparing business cards…",
      "extend": "Extend",
      "export": "Export"
    },
    "extend": {
      "title": "Extend promo codes ({{count}})",
      "expiresOn": "Valid until (MSK, inclusive)",
      "hint": "The date applies to every selected code; empty means no expiry. Expired codes become active again.",
      "clear": "Clear date",
      "submit": "Apply",
      "cancel": "Cancel"
    },
    "panel": {
      "title": "Promo code",
      "close": "Close",
      "qrAlt": "QR code linking to promo code {{code}}",
      "amount": "Amount",
      "redemptions": "Redemptions",
      "limitUnlimited": "unlimited",
      "limitCompanies": "{{count}} companies",
      "expires": "Valid until",
      "openRedemptions": "Open redemptions",
      "link": "Link for the client",
      "params": "Settings",
      "expiresOn": "Valid until, MSK",
      "commentPlaceholder": "what this code is for",
      "createdBy": "Created by",
      "createdAt": "Created",
      "pause": "Pause",
      "cancel": "Cancel",
      "save": "Save"
    },
    "dialog": {
      "createTitle": "New promo code",
      "kind": "Type",
      "kindOpenHint": "Any company may redeem it once. The redemption limit is optional.",
      "kindClosedHint": "Only companies from the list, once each. The limit equals the list.",
      "code": "Code",
      "codePlaceholder": "leave empty to generate",
      "codeHint": "6–32 Latin letters, digits and dashes, no spaces; case is ignored on input. Code and amount cannot be changed after creation.",
      "codeError": {
        "chars": "Latin letters, digits and dashes only — no spaces or Cyrillic.",
        "short": "The code is at least 6 characters long.",
        "long": "The code is at most 32 characters long."
      },
      "amountRub": "Amount (₽)",
      "companies": "Companies",
      "companiesPlaceholder": "Add a company…",
      "companiesEmpty": "Add at least one company.",
      "companyRedeemed": "This company has already redeemed the code — it cannot be removed.",
      "removeCompany": "Remove {{name}}",
      "maxRedemptions": "Redemption limit",
      "maxRedemptionsPlaceholder": "empty — unlimited",
      "expiresOn": "Valid until (MSK, inclusive)",
      "expiresOnPlaceholder": "no expiry",
      "expiresOnClear": "Clear date",
      "comment": "Comment",
      "previewAmount": "The code credits {{amount}}",
      "previewOpenLimited": "open, limit {{count}}",
      "previewOpenUnlimited": "open, unlimited",
      "previewClosed": "closed, companies: {{count}}",
      "previewTill": "until {{date}}",
      "save": "Create",
      "cancel": "Cancel"
    }
  },
  "spendLimits": {
    "title": "Spending limits",
    "hint": "Spend is counted from the 1st of the month together with generations still running. Once a limit is reached, new generations don't start, while started ones finish — so the total may slightly exceed the limit.",
    "description": "A generation starts only if every limit — the member's, the project's and the company's — and the account balance allow it; started generations finish.",
    "selfNote": "A generation starts if every limit allows it. Started ones finish. A company owner can raise the limit.",
    "addLimit": "Add limit",
    "addMenu": {
      "company": "Company limit",
      "memberDefault": "Members by default",
      "member": "A member — in their card on “Members”",
      "project": "A project — in its settings"
    },
    "edit": "Edit",
    "add": "Add",
    "remove": "Remove limit",
    "cancel": "Cancel",
    "close": "Close",
    "save": "Save",
    "companyRule": "Company",
    "memberDefaultRule": "Members by default",
    "noLimit": "No limit",
    "spentPrefix": "spent",
    "spentShare": "{{percent}} of the limit spent",
    "clickToEdit": "click to change",
    "inProgressSuffix": ", of which {{amount}} in progress",
    "inProgressShort": "of which {{amount}} in progress",
    "leftPrefix": "left",
    "defaultRuleLine": "everyone without a limit of their own, owners included · now {{on}} of {{total}}",
    "nearLimit": "near the limit:",
    "exceptionsTitle": "Exceptions and projects · {{count}}",
    "exceptionsNote": "other members are on the default, other projects have no limit",
    "exceptionsEmpty": "No exceptions: every member is on the default and no project has a limit. A member's limit is set in their card on “Members”, a project's — in the project settings.",
    "colWho": "Who",
    "colLimit": "Limit",
    "colSpent": "Spent",
    "colLeft": "Left",
    "tagDefault": "default",
    "tagCustom": "custom",
    "tagUnlimited": "no limit",
    "tagProject": "project",
    "footHint": "Limits are counted per calendar month and reset on the 1st at {{time}} (your local time).",
    "offTitle": "Spending limits work in the “Reconciliation” and “Enforced” modes",
    "offBody": "Billing of “{{company}}” is switched off: generations neither reserve nor charge funds, so limits don't apply and a new one can't be set. The billing mode is switched by a platform super admin. Limits set earlier are kept and start working again once the mode is restored.",
    "overdraft": {
      "title": "Overdraft allowance",
      "usedUp": "used up",
      "description": "How far the account may go negative in the “Reconciliation” mode before new generations stop. The overdraft is settled by topping up the balance; the size is set by Frameriver.",
      "edit": "Change allowance",
      "unavailable": "Available only in Reconciliation mode.",
      "limit": "Allowance",
      "limitSub": "set by Frameriver",
      "used": "Used",
      "usedSub": "of the allowance",
      "usedNone": "balance is positive — allowance untouched",
      "usedStopped": "new generations are paused — top up the balance",
      "dialog": {
        "title": "Overdraft allowance",
        "description": "How far the “{{name}}” account may go negative in the “Reconciliation” mode. The client sees the amount; only a super admin can change it.",
        "amount": "Amount",
        "hint": "New generations stop once the available balance on the charge account falls below −this amount. 0 means no overdraft."
      }
    },
    "state": {
      "default": "Default",
      "custom": "Custom",
      "unlimited": "No limit"
    },
    "topupUntil": "+ {{amount}} until {{date}}",
    "tile": {
      "of": "of {{limit}}",
      "topup": "including {{amount}} until the end of the month"
    },
    "resetsAt": "Resets {{date}} at {{time}}",
    "resetsAtLower": "resets {{date}} at {{time}}",
    "dialog": {
      "memberTitle": "Spending limit — {{name}}",
      "memberDescription": "Spending ceiling per calendar month.",
      "defaultTitle": "Default spending limit",
      "defaultDescription": "The amount for everyone with “Default” selected — owners included.",
      "projectTitle": "Spending limit of project “{{name}}”",
      "projectDescription": "How much the project may spend per calendar month — whichever account the money is charged to.",
      "companyTitle": "Company spending limit",
      "companyDescription": "The ceiling of “{{name}}” per month — for all generations of members, owners and projects.",
      "offDescription": "Spending ceiling per calendar month.",
      "whichApplies": "Which limit applies",
      "segmentDefault": "Default",
      "segmentCustom": "Custom",
      "segmentUnlimited": "No limit",
      "defaultSub": "The company's default limit for members applies.",
      "customSub": "A custom amount replaces the default limit.",
      "amount": "Amount",
      "amountDefault": "Amount · default",
      "moreThanAmount": "more than the amount",
      "calcInMonthSpent": "In {{month}} spent",
      "calcOfWhich": "of which",
      "calcInProgress": "in progress",
      "calcWillRemain": "remaining",
      "calcRemains": "left",
      "warnSpent": "In {{month}} {{spent}} has already been spent{{inProgress}} — more than the new amount.",
      "warnInProgress": " (of which {{amount}} in progress)",
      "warnMember": "After saving, this member's new generations won't start until {{date}}; started ones will finish.",
      "warnProject": "After saving, new generations in the project won't start until {{date}}; started ones will finish.",
      "warnCompany": "After saving, new generations in the company won't start until {{date}}; started ones will finish.",
      "defaultNote": "Changes at once for everyone on “Default”.",
      "defaultConfirmTitle": "Change the default limit?",
      "defaultConfirm": "{{amount}} will change for everyone on the default limit.",
      "unlimitedTitle": "No personal limit",
      "unlimitedBody": "{{name}} spends without a personal limit. Project and company limits still apply.",
      "unlimitedBodyCompany": "{{name}} spends without a personal limit. Project and company limits still apply: the company has {{left}} of {{limit}} left until {{date}}.",
      "unlimitedOwners": "The default limit applies to owners too — that's why “No limit” is chosen explicitly.",
      "appliesToPrefix": "Applies to",
      "appliesToCount": "{{on}} of {{total}}",
      "appliesToSuffix": "people.",
      "atLimitList": "Near the limit · {{count}}",
      "atLimitAside": "80 % and more",
      "customList": "Custom · {{count}}",
      "unlimitedList": "No limit · {{count}}",
      "projectNote": "The limit and “Charged to account” are independent: the account is where the money comes from, the limit is how much the project may spend per month from any account. Generations stop when either runs out.",
      "projectHidden": "The project team doesn't see the amounts — once the limit is reached, they get a refusal without figures.",
      "companyHidden": "Members don't see the amount — once the limit is reached, they get a refusal without figures.",
      "offBody": "Billing of “{{company}}” is switched off: generations neither reserve nor charge funds, so limits don't apply.",
      "offSaved": "The saved limit of {{amount}} is not deleted and will apply again once the mode is restored.",
      "offSavedUnlimited": "The saved “No limit” state is kept and will apply again once the mode is restored.",
      "offMode": "The billing mode is switched by a platform super admin.",
      "changedBy": "Changed {{date}} · {{name}}",
      "changed": "Changed {{date}}",
      "topup": "Extra this month",
      "topupHint": "Does not change the limit. Lasts until the reset, then it is gone.",
      "topupCalc": "In {{month}} they can spend {{total}} ({{base}} + {{extra}})."
    }
  },
  "projectBilling": {
    "headTitle": "Project billing",
    "title": "Billing",
    "spentTotal": "Total spent",
    "inProgress": "In progress",
    "inProgressHint": "Held for running generations: charged on completion, the rest returns to the account",
    "account": "Paying account",
    "noAccount": "No account yet",
    "accountOther": "{{currency}} account",
    "limit": "Project limit",
    "noLimit": "No limit",
    "limitUsed": "{{spent}} of {{amount}} this month",
    "limitSetup": "Configure",
    "platformDashboard": "Platform",
    "historyCurrencyNote": "Project history in {{currency}}, before the project moved to {{projectCurrency}}. The limit and the paying account apply in {{projectCurrency}}.",
    "byModels": "By models",
    "discount": "Project discount {{percent}}%",
    "byJobKinds": "By generation kinds"
  },
  "proposals": {
    "title": "Commercial proposals",
    "new": "New proposal",
    "create": "Create",
    "createTitle": "New proposal",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "downloadPdf": "Download PDF",
    "deleteConfirm": "Delete proposal {{number}}? The number will not be reused.",
    "unsaved": "Unsaved changes",
    "author": "Author: {{name}}",
    "empty": "No proposals yet",
    "allStatuses": "All statuses",
    "searchPlaceholder": "Number, client or tax ID",
    "withoutRequisites": "no requisites",
    "inn": "Tax ID {{inn}}",
    "companySearch": "Search companies",
    "companyPlaceholder": "Choose a company",
    "requisites": "In the proposal: {{name}}, tax ID {{inn}}.",
    "noRequisites": "No requisites — the proposal will show the company name only.",
    "addresseePlaceholder": "To the CEO, Mr. Ivanov",
    "depositCreditPlaceholder": "Above the top-up — a bonus",
    "termsNotePlaceholder": "Account manager, team training, support…",
    "preview": "Proposal preview",
    "previewLoading": "Preparing preview…",
    "previewFailed": "Preview failed: {{message}}",
    "status": {
      "draft": "Draft",
      "sent": "Sent",
      "accepted": "Accepted",
      "rejected": "Rejected",
      "expired": "Expired"
    },
    "columns": {
      "number": "Number",
      "company": "Client",
      "issuedOn": "Date",
      "validUntil": "Valid until",
      "seats": "Seats",
      "deposit": "Top-up",
      "discount": "Discount",
      "status": "Status",
      "author": "Author"
    },
    "sections": {
      "client": "Client",
      "document": "Document",
      "features": "Platform capabilities",
      "terms": "Terms",
      "appendix": "Appendices and signature",
      "examples": "Cost examples"
    },
    "fields": {
      "company": "Company",
      "priceList": "Price list",
      "addressee": "Addressee",
      "issuedOn": "Proposal date",
      "validUntil": "Valid until",
      "seats": "Seats",
      "discount": "Discount, %",
      "discountMonths": "Discount term, months",
      "deposit": "First top-up, {{currency}}",
      "depositCredit": "Credited to balance, {{currency}}",
      "models": "Models",
      "termsNote": "Additional terms",
      "includePriceList": "Price list appendix",
      "committedMinutes": "Commitment, generated minutes",
      "showContact": "Contact person",
      "contactName": "Name",
      "contactEmail": "Email"
    },
    "plans": {
      "apply": "Fill from a billing plan",
      "discount": "{{name}} — {{percent}}% off for {{months}} mo.",
      "deposit": "{{name}} — pay {{price}}, credit {{credit}}"
    },
    "models": {
      "title": "Models in the proposal",
      "apply": "Apply",
      "choose": "Choose",
      "all": "All price list models ({{count}})",
      "selected": "Selected {{count}} of {{total}}"
    },
    "features": {
      "open": "Block texts",
      "title": "“Platform capabilities” blocks",
      "description": "Order here is the order in the proposal. Disabled blocks are not offered for new proposals.",
      "add": "Add block",
      "active": "Offer in new proposals",
      "titlePlaceholder": "Block title",
      "bodyPlaceholder": "Description, 1–2 sentences",
      "moveUp": "Up",
      "moveDown": "Down",
      "remove": "Remove block"
    },
    "examples": {
      "choose": "Choose rows",
      "title": "Cost examples",
      "selected": "Selected: {{count}}",
      "empty": "The block will be left out.",
      "missing": "no rate in this price list, left out",
      "audio": "with audio",
      "single": "single price"
    },
    "committedMinutesPlaceholder": "No commitment",
    "committedMinutesHint": "Terms apply with a commitment to this video volume; the proposal notes that terms may improve for larger volumes."
  },
  "spendReports": {
    "title": "Spend reports",
    "new": "New report",
    "searchPlaceholder": "Number, title or company",
    "empty": "No reports yet. A new report covers last month.",
    "platformWide": "Whole platform",
    "columns": {
      "number": "Number",
      "title": "Title",
      "scope": "Scope",
      "period": "Period",
      "author": "Author",
      "updated": "Updated"
    },
    "createTitle": "New spend report",
    "createHint": "The draft covers last month; period, projects and sections are set in the editor.",
    "create": "Create",
    "cancel": "Cancel",
    "sections": {
      "scope": "Scope",
      "period": "Period",
      "sections": "Sections",
      "detail": "Detail",
      "design": "Layout"
    },
    "fields": {
      "company": "Company",
      "projects": "Projects",
      "from": "From",
      "to": "To",
      "compare": "Comparison",
      "currency": "Currency",
      "topN": "Rows per table",
      "grouping": "Trend",
      "title": "Title",
      "comment": "Comment on the first page"
    },
    "titlePlaceholder": "Spend report",
    "commentPlaceholder": "E.g. growth driven by the new commercial shoot",
    "compare": {
      "previous": "Previous period",
      "none": "No comparison"
    },
    "topAll": "All",
    "topHint": "Remaining rows collapse into “N more …”; totals stay the same.",
    "grouping": {
      "day": "Days",
      "week": "Weeks",
      "month": "Months"
    },
    "presets": {
      "prevMonth": "Last month",
      "thisMonth": "This month",
      "prevQuarter": "Last quarter",
      "ytd": "Year to date"
    },
    "projects": {
      "all": "All projects · {{count}}",
      "selected": "{{count}} of {{total}}",
      "choose": "Choose",
      "title": "Projects in the report",
      "apply": "Apply",
      "selectAll": "Select all",
      "clearAll": "Clear all",
      "search": "Search projects",
      "empty": "No projects",
      "platformHint": "Projects can be chosen for a single-company report."
    },
    "sectionLabels": {
      "summary": "Period totals",
      "facts": "Key points",
      "kinds": "Spend by generation type",
      "daily": "Spend trend",
      "companies": "Companies",
      "projects": "Projects",
      "models": "Models",
      "models_chart": "“Spend vs volume” chart",
      "users": "Team members",
      "project_kinds": "Projects × generation types",
      "users_projects": "Team members × projects",
      "method": "Methodology"
    },
    "flags": {
      "show_emails": "Team member emails",
      "show_providers": "Model providers",
      "show_errors": "Generation error rate",
      "show_contact": "Account manager contact (report author)"
    },
    "save": "Save",
    "delete": "Delete",
    "deleteConfirm": "Delete report {{number}}?",
    "unsaved": "Unsaved changes",
    "author": "Author: {{name}}",
    "downloadPdf": "Download PDF",
    "preview": "Report preview",
    "previewLoading": "Building PDF…",
    "previewFailed": "Could not build the preview: {{message}}"
  }
}
